var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[(_vm.link == '')?[_vm._v(_vm._s(_vm.label))]:_c('a',{staticClass:"text-arclight",attrs:{"href":_vm.link,"target":_vm.target}},[_vm._v(_vm._s(_vm.label))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }